export type ProjectName = string;
export type ProjectId = string;
export interface Project {
  name: ProjectName;
  id: ProjectId;
}

export const DEFAULT_PROJECT_ID = '00000000-0000-0000-0000-000000000000';
export const USER_FILES = 'My BRio';
